import React from 'react';
import Util from './Util';
import { Article, Chat, Cloud, Pageview } from '@mui/icons-material';
import { Box, Button, SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import { useDrawer } from './context/DrawerContext';



const SubjectContext = props => {
    const s = props.subject;
    const exclusions = props.exclude
    const {openDrawer} = useDrawer()

    const menuItems = []

    const ContextMenuItem = props => {
      return (<SpeedDialAction key={props.content} onClick={() => openDrawer(props.section, props.options)} icon={props.icon} />);
    }

    const addMenuItem = a => {
      const label = a?.props?.content
      const exclude = exclusions !== null && exclusions !== undefined && exclusions.indexOf(label) !== -1
      if (!exclude) {
        menuItems.push(a)
      }
    }
    
    addMenuItem(
      <SpeedDialAction icon={<Pageview />} section={section(s)} options={{subject: s}} content='View' />    
    )

    if (s?.id && s?.type) {
      addMenuItem(
        <ContextMenuItem icon={<Chat />} section='forecast' options={{subject: s}} content='Discuss' />    
      )
    }

    if (s?.type === 'PLACE') {
        addMenuItem(
            <ContextMenuItem icon={<Cloud />} section='forecast' options={{subject: s}} content='Weather' />    
        )
    }

    if (s?.type === 'RECORD' && props.account?.roles?.includes("POWER")) {
      addMenuItem(
        <ContextMenuItem icon={<Article />} link={`${process.env.REACT_APP_REST_URI}/record/${s.id}`} content='Data' />
      )
    }

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button onClick={() => {
          if (s.type === 'TRAVEL') {
            openDrawer('drive', {subject: s})
          }
        }}>{s.label}</Button>
        <SpeedDial 
          direction="right" 
          icon={<SpeedDialIcon sx={{ fontSize: 16 }} />} 
          open={props.open} 
          ariaLabel='Menu'
          sx={{
            '& .MuiSpeedDial-fab': {
              width: 36,    // Default is 56
              height: 36,   // Default is 56
              minHeight: 36 // Override min-height
            }
          }}      
          >
            {menuItems}
        </SpeedDial>
    </Box>
  )
}

const section = s => {
    if (s?.type === 'TRAVEL') {
      return 'drive'
    }
    return null
  }

export default SubjectContext;